// Links into the map (MAP3): a map by its slug, and optionally a pin to select. Built on the server
// wherever something has a place, followed by "Show on map" in the web app.

/** A map's name in the URL: "Stranglethorn Vale" → "stranglethorn-vale", "Zul'Farrak" → "zulfarrak". */
export const mapSlug = (name: string) =>
  name
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

/** Where something is on the map: the map's slug, and the pin to select there, if any. */
export interface MapLink {
  slug: string;
  pin: string | null;
}

/** The web path of a map link, keeping a character when given. */
export function mapHref(link: MapLink, character?: string | null): string {
  const q: string[] = [];
  if (character) q.push(`character=${encodeURIComponent(character)}`);
  if (link.pin) q.push(`pin=${encodeURIComponent(link.pin)}`);
  return `/map/${link.slug}${q.length ? `?${q.join('&')}` : ''}`;
}
